export default __webpack_public_path__ + "static/media/bg_tile.a155c1bc.jpg";